import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const ContraIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 25 24",
    },
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.888 11.35H23.79c.124 0 .224-.1.224-.224v-.334a.224.224 0 0 0-.168-.217A14.6 14.6 0 0 1 13.376.167.224.224 0 0 0 13.158 0h-.271c-.124 0-.224.1-.224.224v10.902c0 .123.1.224.224.224M12.888 24h.334a.22.22 0 0 0 .217-.168 14.6 14.6 0 0 1 10.408-10.47.224.224 0 0 0 .167-.217v-.271c0-.123-.1-.224-.224-.224H12.888c-.124 0-.224.1-.224.224v10.902c0 .124.1.224.224.224M10.855 24h.27c.124 0 .224-.1.224-.224V12.874c0-.123-.1-.224-.223-.224H.224c-.124 0-.224.1-.224.224v.334c0 .102.069.191.168.217a14.6 14.6 0 0 1 10.47 10.408.224.224 0 0 0 .216.167M.224 11.35h10.902c.123 0 .223-.1.223-.224V.224c0-.124-.1-.224-.223-.224h-.334a.224.224 0 0 0-.217.168A14.6 14.6 0 0 1 .167 10.638a.22.22 0 0 0-.167.217v.271c0 .123.1.224.224.224"
      clipRule="evenodd"
    />
  );
